import React, {
  Component
}                         from 'react';
import PropTypes          from 'prop-types';
import {
  AnimatedView,
  StatsTable,
  MaterialList,
  StatsGraph
}                         from '../../../components';
import {
  defaultOptions,
  checkStatus,
  parseJSON,
  getLocationOrigin
}                     from '../../../services/fetchTools';
import CircularProgress from 'material-ui/CircularProgress';
import { Table } from 'reactstrap';
var Spinner = require('react-spinkit');

class LeadsDailyList extends Component{
  static propTypes = {
    actions: PropTypes.shape({
      enterPage: PropTypes.func,
      leavePage: PropTypes.func
    })
  };
  constructor(props){
    super(props);
    const search = props.location.search; // returns the URL query String
    const params = new URLSearchParams(search);
    this.state = {
      venue: props.statsTable.revenue_per_month.requested_venue_id,
      date: params.get("date"),
      lead_details:[],
      lead_headers:[],
      loading:false
    }
  }

  componentDidMount() {
    this.locationChanged()
  }

  locationChanged() {
    this.setState({venue:this.props.statsTable.revenue_per_month.requested_venue_id,loading:false}, () => {
      this.getdailyleads()    
    })
  }

  getdailyleads(){
    const url = `${getLocationOrigin()}/eagleeye/getTableData/?report_id=7643&venue_id=${this.state.venue}&date=${this.state.date}`;
    const options = {...defaultOptions};

    return fetch(url, options)
       .then(checkStatus)
       .then(parseJSON)
       .then(data => {
            this.setState({lead_details:data.data,lead_headers:data.headers,loading:true})
           // alert("fix");
       }).catch(error => error);
  }

  render(){
    var headers = []
    if(this.state.lead_headers.length > 0){
      var tab_index = []
      for (var i = 0; i < this.state.lead_headers.length; i++) {
        if(this.state.lead_headers[i].indexOf("_hidden") == -1){
          headers.push(this.state.lead_headers[i]);
          tab_index.push(i);
        }
      }
    }

    if(this.state.venue != this.props.statsTable.revenue_per_month.requested_venue_id){
      this.locationChanged()
    }

    console.log("state",this.state)
    return(
      <div>
        <div className="breadcrumps" style={{marginBottom:'2%'}}>
          <a href={'/#/dashboard/ActiveCustomer'} >
            <span>Dashboard</span>
          </a>
          <a href={'/#/dashboard/LeadsSummary'} >
            <span>Leads Summary</span>
          </a> 
          <a>
            <span>Leads Daily List</span>
          </a>  
        </div>
        
      {this.state.loading ?
        <Table responsive style={{border:'1px solid rgb(101, 70, 138)'}}>
          
            <tr style={{backgroundColor:'rgb(101, 70, 138)',color:'white'}}>
              {
                headers.map(header=>(
                  <th style={{textAlign:'center',height:'40px',width:'14%'}}> {header} </th>
                ))
              }
            </tr>
          <tbody>
            { 
              this.state.lead_details && this.state.lead_details.length > 0 ?
                this.state.lead_details.map((data)=>(
                  <tr style={{backgroundColor:'white'}}>
                    { data.map((each,key)=>
                      tab_index.includes(key) &&
                        <td style={{textAlign:'center'}} dangerouslySetInnerHTML={{__html:each}}></td>
                      )
                    }
                  </tr>
                ))
            :
              <tr></tr>}                        
          </tbody>
        </Table>
       :
       <div style={{height:500}}>
                <div style={{  position: 'absolute',top: '50%',left: '50%'}}><CircularProgress /></div>
            </div>
          }

      </div>
      )
  }

}

export default LeadsDailyList;


// WEBPACK FOOTER //
// ./src/app/views/centerportal/leadsDailyList/LeadsDailyList.js